// src/utils/numberUtils.js
export const formatNumberWithCommas = (value) => {
  if (!value) return '';
  // Remove commas and non-numeric characters
  const numericValue = value.toString().replace(/[^0-9]/g, '');
  if (numericValue === '') return '';
  // Format with commas
  return Number(numericValue).toLocaleString('en-US');
};
